import { AUTH_REMOVE_TOKEN, AUTH_SET_TOKEN, REFRESH_USER_DATA } from './authActions';

const initialState = {
  token: null,
  loggedInUser: null,
};

export default function authReducer(state = initialState, action) {
  switch (action.type) {
    case AUTH_SET_TOKEN:
      return {
        ...state,
        token: action.payload.token,
        loggedInUser: action.payload.user,
      };
    case AUTH_REMOVE_TOKEN:
      return {
        ...state,
        token: null,
        loggedInUser: null,
      };
    case REFRESH_USER_DATA:
      return {
        ...state,
        loggedInUser: {
          ...state.loggedInUser,
          ...action.payload.fresh_user,
        },
      };
    default:
      return state;
  }
}
